import request from '@/utils/request'

/**
 *获取员工列表
 * @param {*} data 
 */
export function getAdminList(data){
    return request({
        url: '/web/admin/list',
        method: 'post',
        data
    })
}

/**
 *	十二、添加或修改员工
 * @param {*} data 
 */
export function  adminAdd(data){
    return request({
        url: '/web/admin/add',
        method: 'post',
        data
    })
}


/**
 *十四、删除员工
 * @param {*} data 
 */
export function adminDelete(data){
    return request({
        url: '/web/admin/delete',
        method: 'post',
        data
    })
}
/**
 *十三、修改密码
 * @param {*} data 
 */
export function updatePwd(data){
    return request({
        url: '/web/admin/updatePwd',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/admin.js